import { StatsActions } from './constants'
import { Map } from 'immutable'
import getBool from 'aria-viewer/utils/getBool'
import { getEnv } from 'aria-viewer/utils/environment'

const calculateMean = totalTime => {
    let meanValues = []

    return (interval, meanValue) => {
        const maxMeanSize = totalTime / interval

        if (meanValues.length >= maxMeanSize) meanValues.shift()

        meanValues.push(meanValue)

        return meanValues.reduce((acc, cur) => acc + cur, 0) / meanValues.length
    }
}

const calculateOneMinuteInterval = calculateMean(60)
const calculateFiveMinuteInterval = calculateMean(60 * 5)

const isFPSMeterEnabled = getBool(getEnv('REACT_APP_ENABLE_FPS_METER'))
const fpsMeterInterval = parseInt(getEnv('REACT_APP_FPS_METER_INTERVAL'))

const INITIAL_STATE = Map({
    enableStats: false,
    enableFPSMeter: isFPSMeterEnabled,
    fpsMeterInterval: fpsMeterInterval,
    calculatedFPS: Map({
        mean: undefined,
        min: undefined,
        max: undefined,
        ['1_min_mean']: undefined,
        ['5_min_mean']: undefined,
    }),
})

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case StatsActions.SET_STATS_ENABLED:
            return state.set('enableStats', action.enabled)
        case StatsActions.SET_MEAN_FPS:
            const min = state.getIn(['calculatedFPS', 'min'])
            const max = state.getIn(['calculatedFPS', 'max'])
            const { meanFPS, interval } = action

            const calculatedMin = min == undefined ? meanFPS : Math.min(min, meanFPS)
            const calculatedMax = max == undefined ? meanFPS : Math.max(max, meanFPS)

            return state.mergeIn(['calculatedFPS'], {
                mean: meanFPS,
                max: calculatedMax,
                min: calculatedMin,
                ['1_min_mean']: calculateOneMinuteInterval(interval / 1000, meanFPS),
                ['5_min_mean']: calculateFiveMinuteInterval(interval / 1000, meanFPS),
            })
        case StatsActions.SET_FPS_METER_ENABLED:
            return state.set('enableFPSMeter', action.enabled)
        default:
            return state
    }
}
